import * as d3 from 'd3';
import Api from "../Api";
import Thinker from "../components/Thinker";

const StackedBarChart = function (options) {
    const container = $(options.container);

    function render() {
        const margin = {top: 30, right: 30, bottom: 30, left: 50},
            width = container.width() - margin.left - margin.right,
            height = 300 - margin.top - margin.bottom;

        const x = d3.scaleBand()
            .range([0, width])
            .padding([0.2]);

        const y = d3.scaleLinear()
            .range([height, 0]);

        const svg = d3.select(options.svg)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        const tip = d3.select('body')
            .append('div')
            .attr('class', 'bar-tip')
            .style('opacity', 0)
            .html(`
                <div class="bar-tip-title"></div>
                <div class="bar-tip-body">
                    <span class="bar-label">${options.bar1label}: <span class="bar1-count"></span></span>
                    ${ options.bar2label ? `<span class="bar-label">${options.bar2label}: <span class="bar2-count"></span></span>`: ''}
                </div>`);

        Api.send(container.data('url')).done(function (results) {
            Thinker.end($(options.container));
            x.domain(results.map(d => d.label));
            y.domain([0, d3.max(results, d => +d.bar1)]).nice();

            const bars1 = svg.selectAll('.bar1')
                .data(results)
                .enter();

            bars1.append('rect')
                .attr('class', 'bar1')
                .attr('x', d => x(d.label))
                .attr('width', x.bandwidth())
                .attr('y', height)
                .attr('height', 0)
                // animate bars coming out
                .transition()
                .attr('y', d => y(+d.bar1))
                .attr('height', d => height - y(d.bar1))
                .delay((d, i) => i * 20)
                .duration(2000);

            const bars2 = svg.selectAll('.bar2')
                .data(results)
                .enter();

            bars2.append('rect')
                .attr('class', 'bar2')
                .attr('x', d => x(d.label))
                .attr('width', x.bandwidth())
                .attr('y', height)
                .attr('height', 0)
                // animate bars coming out
                .transition()
                .attr('y', d => y(d.bar2))
                .attr('height', d => height - y(d.bar2))
                .delay((d, i) => (i * 20) + 200)
                .duration(2000);

            svg.append('g')
                .attr('transform', `translate(0, ${height})`)
                .call(d3.axisBottom(x));

            svg.append('g')
                .call(d3.axisLeft(y));

            svg.selectAll('rect').on('mouseover', function (event, d) {
                const $rect = $(this);
                tip.transition()
                    .duration(200)
                    .style('opacity', 1)
                    .style('visibility', 'visible');
                tip.style('left', function () {
                    const rightBound = $(options.container).offset().left + $(options.container).outerWidth();
                    let position = $rect.offset().left + $rect.outerWidth();
                    if (position + $(this).outerWidth() > rightBound) {
                        // position on left if it goes off the screen
                        position = $rect.offset().left - $(this).outerWidth() - 5;
                    } else {
                        // add some padding
                        position += 5;
                    }
                    return position + 'px';
                }).style('top', function () {
                    return ($rect.offset().top + ($rect.outerHeight() / 2) - ($(this).outerHeight() / 2)) + 'px';
                });
                tip.select('.bar-tip-title').text(d.label);
                tip.select('.bar1-count').text(d.bar1);
                tip.select('.bar2-count').text(d.bar2);
            }).on('mouseout', function () {
                tip.transition()
                    .duration(200)
                    .style('opacity', 0)
                    .style('visibility', 'hidden');
            }).on('click', function (event, d) {
                if (options.link && options.param) {
                    let url = `${options.link}?${options.param}=${d.index}`
                    if (container.data('filters')) {
                        url += `&${container.data('filters')}`;
                    }
                    window.location.href = url;
                }
            });
        });
    }

    setTimeout(function () {
        Thinker.begin($(options.container));
        render();
    }, 100);

    function update() {
        $(options.svg).empty();
        Thinker.begin($(options.container));
        setTimeout(function () {
            render();
        }, 500);
    }

    $('body').on('click', '.hamburger a', function () {
        $(options.container).trigger('update');
    });

    $(options.container).on('update', function () {
        update();
    });
};

export default StackedBarChart;
